<template>
  <Footer class="app-footer">
    <p>© 2021 上海九罗科技 有限公司 版权所有</p>
  </Footer>
</template>
<script>
export default {
  name: 'AppFooter'
}
</script>
<style lang="less">
  @import '../../assets/less/base/variables.less';
  .app-footer {
    margin: 40px 0 0 0;
    padding: 12px 24px;
    border-radius: 4px;
    background-color: white;
  }
</style>
